import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload-pic",
  "use": "icon-upload-pic-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\" \" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload-pic\">\r\n<g id=\"icon-upload-pic_upload\">\r\n<path id=\"icon-upload-pic_Union\" d=\"M8.00033 1.72388L11.9431 5.66669L11.0003 6.60949L8.66699 4.27616L8.66699 10.6667H7.33366L7.33366 4.27616L5.00033 6.60949L4.05752 5.66669L8.00033 1.72388ZM3.00033 9.33335V12.6667H13.0003V9.33335H14.3337V14H1.66699V9.33335H3.00033Z\" fill=\" \" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol